import { DisconnectionOverlay } from "@/components/DisconnectionOverlay"
import { WithChildren } from "@/utils/utilityTypes"

export const TornOut = ({ children }: WithChildren) => (
  <>
    {children}
    <DisconnectionOverlay />
  </>
)
